import { makeStyles } from '@mui/styles';

const useCandidateInfoStyle = makeStyles(() => ({
  container: {
    padding: '30px 30px 30px 260px',
  },
}));

export default useCandidateInfoStyle;
